import { FC } from "react";
import { Stack, SxProps, useTheme } from "@mui/material";
import CustomPaper from "../components/ui/CutomPaper";
import Text from "./Text";

interface BadgePaperProps {
  label: string;
  value: string | number;
  sx?: SxProps;
}

const BadgePaper: FC<BadgePaperProps> = ({ label, value, sx }) => {
  const theme = useTheme();

  return (
    <CustomPaper sx={sx}>
      <Stack direction="column" gap={1} flexGrow={1}>
        <Text variant="h3" color={theme.myTheme.colors.foreground100}>
          {value ? value : "N/A"}
        </Text>
        <Text variant="regular" color={theme.myTheme.colors.foreground50}>
          {label}
        </Text>
      </Stack>
    </CustomPaper>
  );
};

export default BadgePaper;
